import { render } from "./IconElectraBattery.vue?vue&type=template&id=7f7cf85a"
import script from "./IconElectraBattery.vue?vue&type=script&lang=js"
export * from "./IconElectraBattery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__